import { isDeviceMobile } from '../../../../helpers/helpers';

export default function TextInputField({
  label,
  fieldName,
  value,
  onInputChange,
  config,
  removeFromList = null,
}) {
  const handleInputChange = (e) => {
    // if (config?.isSameValue) {
    if (config?.formatToNumber) {
      let rawValue = e.target.value.replace(/[^0-9.]/g, ''); // Remove non-numeric characters except dot (if you're allowing decimal numbers)

      // Format the value with commas
      let formattedValue = rawValue
        ? parseInt(rawValue, 10).toLocaleString()
        : '';

      onInputChange({
        ...e,
        target: {
          ...e.target,
          value: formattedValue,
        },
      });
    } else {
      onInputChange({
        ...e,
        value: e.target.value,
      });
    }

    // }
  };
  return (
    <div className="mb-3  w-100 d-flex flex-column">
      <label htmlFor={fieldName} className="form-label">
        {label}
      </label>
      <input
        type="text"
        id={fieldName}
        value={value}
        onChange={handleInputChange}
        name={fieldName}
        className="form-control"
      />
      {removeFromList && (isDeviceMobile() || config.lang == 'ar') && (
        <button
          type="button"
          className="btn btn-danger mt-2 remove_button_height custom_button_desktop"
          onClick={removeFromList}
        >
          Remove
        </button>
      )}

      {removeFromList && !isDeviceMobile() && config.lang == 'en' && (
        <div className="remove_button_height  mt-2 " />
      )}
    </div>
  );
}
